/* ------------------------------------------------------------------------ */
/*  AddArticles.jsx  (Version Cloudinary + react-hot-toast)                 */
/* ------------------------------------------------------------------------ */
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUserContext } from '../contexts/UserContext';
import Navbar from './Navbar';
import Footer from './Footer';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { API_URL } from '../config/api';

const groupesOptionsBase = [
  'Cartes PSN', 'PS4', 'PS5','PS4 & PS5', 'Cartes iTunes','Boutiques','CD'
];

const categoriesParGroupeBase = {
  'Cartes PSN': ['Recharge', 'Abonnement'],
  PS4: ['Sport', 'Action', 'Aventure', 'Course', 'Horreur', 'RPG', 'Combat','FPS'],
  PS5: ['Sport', 'Action', 'Aventure', 'Course', 'Horreur', 'RPG', 'Combat','FPS'],
  'PS4 & PS5':['Sport', 'Action', 'Aventure', 'Course', 'Horreur', 'RPG', 'Combat','FPS'],
  'Cartes iTunes': ['Recharge', 'Abonnement'],
  Boutiques : ['PS4','PS5'],
  CD : ['PS4','PS5'],
};

const marquesParGroupeBase = {
  'Cartes PSN': ['PlayStation', 'Sony', 'Apple','Nintendo', 'Google'],
  PS4: ['EA Sports', 'Activision', '2K Sports', 'Marvel','Remedy Entertainment','Epic Games Publishing','Rockstar Games','Ubisoft','Sony Interactive','Square Enix','Capcom','Bandai Namco','Warner Bros'],
  PS5: ['EA Sports', 'Activision', '2K Sports', 'Marvel','Remedy Entertainment','Epic Games Publishing','Rockstar Games','Ubisoft','Sony Interactive','Square Enix','Capcom','Bandai Namco','Warner Bros'],
  'PS4 & PS5': ['EA Sports', 'Activision', '2K Sports', 'Marvel','Remedy Entertainment','Epic Games Publishing','Rockstar Games','Ubisoft','Sony Interactive','Square Enix','Capcom','Bandai Namco','Warner Bros'],
  'Cartes iTunes': ['PlayStation', 'Sony', 'Apple', 'Nintendo', 'Google', 'Apple Music', 'Xbox', 'Netflix', 'Stream'],
   Boutiques : ['Sony'],
   CD : ['EA Sports', 'Activision', '2K Sports', 'Marvel','Remedy Entertainment','Epic Games Publishing','Rockstar Games','Ubisoft','Sony Interactive','Square Enix','Capcom','Bandai Namco','Warner Bros'],
};

export default function AddArticles() {
  const navigate = useNavigate();
  const { user, logout } = useUserContext();

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    title: '', reference: '', label: '', categorie: '',
    prixAchat: '', price: '', promotion: 0,
    description: '', groupe: '',
    stock: 0, disponible: true, poids: '',
    videoUrl: '', nouveaute: false,
  });

  const [img, setImg] = useState(null);
  const [imgPreview, setImgPreview] = useState(null);
  const [images, setImages] = useState([]);
  const [imagesPreview, setImagesPreview] = useState([]);

  const [groupesOptions, setGroupesOptions] = useState(groupesOptionsBase);
  const [categoriesParGroupe, setCategoriesParGroupe] = useState(categoriesParGroupeBase);
  const [marquesParGroupe, setMarquesParGroupe] = useState(marquesParGroupeBase);

  const [availableCategories, setAvailableCategories] = useState([]);
  const [availableMarques, setAvailableMarques] = useState([]);

  const [addingGroup, setAddingGroup] = useState(false);
  const [addingCategory, setAddingCategory] = useState(false);
  const [addingMarque, setAddingMarque] = useState(false);

  const [newGroup, setNewGroup] = useState('');
  const [newCategory, setNewCategory] = useState('');
  const [newMarque, setNewMarque] = useState('');

  useEffect(() => {
    if (!user) {
      navigate('/');
      return;
    }
    setLoading(false);
  }, [user, navigate]);

  useEffect(() => {
    setAvailableCategories(categoriesParGroupe[formData.groupe] || []);
    setAvailableMarques(marquesParGroupe[formData.groupe] || []);
    setFormData((p) => ({ ...p, categorie: '', label: '' }));
  }, [formData.groupe, categoriesParGroupe, marquesParGroupe]);

  useEffect(() => {
    if (img) {
      const url = URL.createObjectURL(img);
      setImgPreview(url);
      return () => URL.revokeObjectURL(url);
    }
    setImgPreview(null);
  }, [img]);

  useEffect(() => {
    if (images.length) {
      const urls = images.map((f) => URL.createObjectURL(f));
      setImagesPreview(urls);
      return () => urls.forEach((u) => URL.revokeObjectURL(u));
    }
    setImagesPreview([]);
  }, [images]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((p) => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleAddGroup = () => {
    const g = newGroup.trim();
    if (!g) return toast.error('Saisissez un groupe.');
    if (groupesOptions.includes(g)) return toast.error('Ce groupe existe déjà.');
    setGroupesOptions((prev) => [...prev, g]);
    setCategoriesParGroupe((prev) => ({ ...prev, [g]: [] }));
    setMarquesParGroupe((prev) => ({ ...prev, [g]: [] }));
    setFormData((p) => ({ ...p, groupe: g, categorie: '', label: '' }));
    setNewGroup('');
    setAddingGroup(false);
  };

  const handleAddCategory = () => {
    const c = newCategory.trim();
    if (!c) return toast.error('Saisissez une catégorie.');
    if (!formData.groupe) return toast.error('Sélectionnez d’abord un groupe.');
    if ((categoriesParGroupe[formData.groupe] || []).includes(c)) return toast.error('Existe déjà.');
    setCategoriesParGroupe((prev) => ({
      ...prev,
      [formData.groupe]: [...(prev[formData.groupe] || []), c]
    }));
    setFormData((p) => ({ ...p, categorie: c }));
    setNewCategory('');
    setAddingCategory(false);
  };

  const handleAddMarque = () => {
    const m = newMarque.trim();
    if (!m) return toast.error('Saisissez une marque.');
    if (!formData.groupe) return toast.error('Sélectionnez d’abord un groupe.');
    if ((marquesParGroupe[formData.groupe] || []).includes(m)) return toast.error('Existe déjà.');
    setMarquesParGroupe((prev) => ({
      ...prev,
      [formData.groupe]: [...(prev[formData.groupe] || []), m]
    }));
    setFormData((p) => ({ ...p, label: m }));
    setNewMarque('');
    setAddingMarque(false);
  };

  const CLOUD_NAME_UPLOAD = "ds3eogn8u";
  const UPLOAD_PRESET_UPLOAD = "codeshop_upload";

  // Upload vers Cloudinary
  const uploadToCloudinary = async (file) => {
    const data = new FormData();
    data.append('file', file);
    data.append('upload_preset', UPLOAD_PRESET_UPLOAD);

    const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME_UPLOAD}/image/upload`, {
      method: 'POST',
      body: data
    });
    const uploaded = await res.json();

    if (!uploaded.secure_url) {
      throw new Error(uploaded.error?.message || 'Erreur upload Cloudinary');
    }

    return uploaded.secure_url;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!img) return toast.error('Image principale obligatoire.');
    if (!user?.id) return toast.error('Session expirée, reconnectez-vous.');

    try {
      toast.loading('Téléversement des images...');
      // Upload image principale
      const imgUrl = await uploadToCloudinary(img);

      // Upload images secondaires
      const otherImgs = await Promise.all(images.map(file => uploadToCloudinary(file)));

      // Préparer les données pour ton backend
      const payload = {
        ...formData,
        prixAchat: parseFloat(formData.prixAchat) || 0,
        price: parseFloat(formData.price) || 0,
        // promotion: parseFloat(formData.promotion) || 0,
        stock: parseInt(formData.stock, 10) || 0,
        disponible: formData.disponible,
        nouveaute: formData.nouveaute,
        img: imgUrl,
        images: otherImgs,
        adminId: user.id,
        videoUrl: formData.videoUrl,
      };

      await axios.post(`${API_URL}/Newproducts`, payload);
      toast.dismiss();
      toast.success('Produit ajouté avec succès !');
      setTimeout(() => navigate('/articles'), 3000);
    } catch (err) {
      console.error(err);
      toast.dismiss();
      toast.error('Erreur lors de l\'ajout.');
    }
  };

  if (loading) return <div>Chargement…</div>;

  return (
    <div className="add-article-page">
      <Navbar logoutHandler={() => { logout(); navigate('/'); }} />
      <div className="container">
        <h1>Ajouter un article</h1>
        <form className="article-form" onSubmit={handleSubmit}>

          {/* Champs texte et nombre */}
          {[
            ['title', 'Nom du produit', 'text'],
            ['reference', 'Référence', 'text'],
            ['prixAchat', 'Prix d’achat', 'number'],
            ['price', 'Prix de vente', 'number'],
            // ['promotion', 'Promotion (%)', 'number'],
            ['stock', 'Stock', 'number'],
            ['videoUrl', 'Lien vidéo YouTube (optionnel)', 'url'],
          ].map(([name, label, type]) => (
            <div className="form-group" key={name}>
              <label>{label}</label>
              <input
                name={name}
                type={type}
                value={formData[name]}
                onChange={handleChange}
                required={name !== 'videoUrl'}
              />
            </div>
          ))}

          {/* Groupe */}
          <div className="form-group">
            <label>Plateforme</label>
            <select name="groupe" value={formData.groupe} onChange={handleChange} required>
              <option value="">Sélectionner</option>
              {groupesOptions.map((g) => <option key={g} value={g}>{g}</option>)}
            </select>
            <button type="button" onClick={() => setAddingGroup(!addingGroup)}>+ Ajouter</button>
            {addingGroup && (
              <div>
                <input value={newGroup} onChange={(e) => setNewGroup(e.target.value)} placeholder="Nouveau groupe" />
                <button type="button" onClick={handleAddGroup}>OK</button>
              </div>
            )}
          </div>

          {/* Catégorie */}
          <div className="form-group">
            <label>Catégorie</label>
            <select name="categorie" value={formData.categorie} onChange={handleChange} required>
              <option value="">Sélectionner</option>
              {availableCategories.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
            <button type="button" onClick={() => setAddingCategory(!addingCategory)}>+ Ajouter</button>
            {addingCategory && (
              <div>
                <input value={newCategory} onChange={(e) => setNewCategory(e.target.value)} placeholder="Nouvelle catégorie" />
                <button type="button" onClick={handleAddCategory}>OK</button>
              </div>
            )}
          </div>

          {/* Marque */}
          <div className="form-group">
            <label>Marque</label>
            <select name="label" value={formData.label} onChange={handleChange} required>
              <option value="">Sélectionner</option>
              {availableMarques.map((m) => <option key={m} value={m}>{m}</option>)}
            </select>
            <button type="button" onClick={() => setAddingMarque(!addingMarque)}>+ Ajouter</button>
            {addingMarque && (
              <div>
                <input value={newMarque} onChange={(e) => setNewMarque(e.target.value)} placeholder="Nouvelle marque" />
                <button type="button" onClick={handleAddMarque}>OK</button>
              </div>
            )}
          </div>

          {/* Nouveau produit */}
          <div className="form-group form-check">
            <input id="nouveaute" type="checkbox" name="nouveaute" checked={formData.nouveaute} onChange={handleChange} />
            <label htmlFor="nouveaute">Marquer comme nouveauté</label>
          </div>

          {/* Description */}
          <div className="form-group">
            <label>Description</label>
            <textarea name="description" value={formData.description} onChange={handleChange} required rows={4} />
          </div>

          {/* Disponible */}
          <div className="form-group form-check">
            <input id="disponible" type="checkbox" name="disponible" checked={formData.disponible} onChange={handleChange} />
            <label htmlFor="disponible">Disponible</label>
          </div>

          {/* Image principale */}
          <div className="form-group">
            <label>Image principale</label>
            <input type="file" accept="image/*" onChange={(e) => setImg(e.target.files[0])} required />
            {imgPreview && <img src={imgPreview} alt="Preview" style={{ maxWidth: 300, borderRadius: 8 }} />}
          </div>

          {/* Images secondaires */}
          <div className="form-group">
            <label>Images secondaires</label>
            <input type="file" accept="image/*" multiple onChange={(e) => setImages(Array.from(e.target.files))} />
            {imagesPreview.length > 0 && imagesPreview.map((src, i) => (
              <img key={i} src={src} alt="" style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 6, marginRight: 5 }} />
            ))}
          </div>

          <div className="form-actions">
            <Link to="/"><button type="button" className="btn cancel">Annuler</button></Link>
            <button type="submit" className="btn save">Enregistrer</button>
          </div>
        </form>
      </div>
      <Footer />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: '8px',
            background: '#333',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}